import { Link } from 'react-router-dom';
import { orderBy, limit } from 'firebase/firestore';
import type { NewsHeadlineDoc } from '@spirits/shared';
import { useCollection } from '../hooks/useCollection';

// Repurposed feed: fires once when a run reaches an ending. Each headline links
// to that run's public recap (/s/:storyId).
export function NewsFeed() {
  const { data: news, loading } = useCollection<NewsHeadlineDoc>('news', orderBy('at', 'desc'), limit(8));
  if (loading && news.length === 0) return null;
  if (news.length === 0) {
    return (
      <aside className="rounded-2xl border border-dashed border-slate-800 p-5 text-sm">
        <p className="text-slate-500">No stories have been told yet. Be the first.</p>
      </aside>
    );
  }
  return (
    <aside className="rounded-2xl border border-slate-800 bg-slate-900/30 p-5">
      <h3 className="text-lg text-slate-200 mb-3">Tales told</h3>
      <ul className="space-y-3">
        {news.map((n) => (
          <li key={n.id} className="text-sm">
            <Link to={`/s/${n.storyId}`} className="group block">
              <p className="text-slate-300">
                <span className="text-amber-200/80">{n.storyTitle}</span>
                {n.endingTitle && <span className="text-slate-500"> · {n.endingTitle}</span>}
              </p>
              <p className="text-slate-200 group-hover:text-amber-100 leading-snug">
                “{n.recapTitle}”
              </p>
              {n.recapBlurb && <p className="text-[12px] text-slate-500 leading-snug mt-0.5">{n.recapBlurb}</p>}
              {n.playerNames?.length > 0 && (
                <p className="text-[11px] mt-0.5 text-violet-300/60">
                  steered by {n.playerNames.join(', ')}
                </p>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}
